import { z } from "zod";
export const VAT_RATES = [2.1, 5.5, 10, 20];
export const VatRateSchema = z.union([
    z.literal(2.1),
    z.literal(5.5),
    z.literal(10),
    z.literal(20),
]);
export const NullableVatRateSchema = VatRateSchema.nullable();
/**
 * Render a VAT rate as a fr-FR display string (decimal separator = ","),
 * intended for inline use inside the "TVA (X%) :" pattern used across the
 * pricing UI and PDF templates. The trailing "%" sign is the caller's
 * responsibility — this function only formats the number itself.
 *
 * Distinct from `formatVatPercent` in computeVat.ts, which returns the
 * fully-localized percent (e.g. "20 %") via Intl. The two coexist on
 * purpose: the inline label needs control over the surrounding text, the
 * Intl variant is used in standalone contexts.
 */
export function formatVatRate(rate) {
    return rate.toString().replace(".", ",");
}
//# sourceMappingURL=vatRate.js.map